import React from 'react';
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { Tabs } from 'antd';

const TabPane = Tabs.TabPane;

class Content extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: 'content6',
  };

  state = {
    show: 0,
  };

  onChange = (key) => {
    this.setState({ show: parseInt(key) })
  }

  getBlockChildren = (item, i) => {
    const tag = item.tag;
    const img = item.img;
    const text = item.text;
    return (
      <TabPane
        key={i}
        tab={(<span
          className={`${this.props.className}-tag`}
          id={`${this.props.id}-tagBlock${i}`}
        >
          <i><img src={tag.icon} width="100%" /></i>
          {tag.tag}
        </span>)}
      >
        <TweenOne.TweenOneGroup
          enter={{ y: 30, delay: 300, opacity: 0, type: 'from', ease: 'easeOutQuad' }}
          leave={null}
          component=""
        >
          {this.state.show === i && (
            <div key="content">
              <div
                className={`${this.props.className}-img`}
                id={`${this.props.id}-imgBlock${i}`}
              >
                {img}
              </div>
              <div
                className={`${this.props.className}-text`}
                id={`${this.props.id}-textBlock${i}`}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>)}
        </TweenOne.TweenOneGroup>
      </TabPane>
    );
  };

  render() {
    const props = { ...this.props };
    delete props.isMode;
    const childrenData = [
      {
        tag: { tag: '团队介绍', icon: 'http://www.hooyee.xyz/images/tuandui.svg' },
        img: <img width="100%" src="http://www.hooyee.xyz/images/team.jpg" />,
        text: `<b>北京回一科技有限公司有限公司</b>，简称：回一科技（HooYee Soft）, 团队组建于2010年，为节约创业成本，因此一直以工作室的方式进行业务。2017年10月10日我们正式成立有限责任制公司。回一科技是互联网领域极具行业创新能力的IoT云平台公司，旗下拥有众多上线产品，提供智能产品打造、超级APP开发、私有云搭建、企业专属SaaS服务，IoT PaaS服务、数据服务等，具备业内罕见的软硬件解决能力、供应链渠道整合能力、数据价值开发能力以及完整的纵向服务基因。公司以规范、诚信为企业经营的基础，专注于互联网+领域，汇聚众多专业背景人才，在产品规划、硬件接入、UI设计、移动开发、云端架构建设、联调测试、数据产品及应用等方面极富经验。`,
      },
      {
        tag: { tag: '公司理念', icon: 'http://www.hooyee.xyz/images/linian.svg' },
        img: <img width="100%" src="http://www.hooyee.xyz/images/linian.png" />,
        text: `<h3>技术</h3>
        公司秉承技术驱动产品的理念，通过实现互联网与移动互联网产品的研究和开发，加上对用户数据分析，日益深入到客户互联网技术建设及运维营销的方方面面，在帮助客户形成自身互联网运作体系的同时，有效对接BAT(百度，阿里，腾讯)等平台即百度搜索、阿里电商、腾讯微信，通过平台的推广来推进互联网综合服务，实现企业、用户、平台三者完美对接，并形成高效互动的枢纽，在帮助客户获取互联网高附加价值的同时获得自身的不断成长和壮大。`,
      },
      {
        tag: { tag: '未来愿景', icon: 'http://www.hooyee.xyz/images/weilai.svg' },
        img: <img width="100%" src="http://www.hooyee.xyz/images/weilai.png" />,
        text: `<h3>创新驱动未来</h3>
        公司作为一家互联网数字服务综合商，其主营业务包括移动互联网应用开发服务、数字互动整合营销服务、互联网网站建设综合服务和电子商务综合服务。一直以来我们为不同行业的知名企业进行了网络品牌重塑，一路的学习、探索、创新，让我们更为自信和充满活力。我们相信，一个优秀的互联网作品有其独特的商业寓意，有其文化和审美的价值，也是先进技术及人机交互学科知识的载体。`,
      },
    ];
    const tabsChildren = childrenData.map(this.getBlockChildren);
    return (
      <div
        {...props}
        className={`content-template-wrapper ${props.className}-wrapper`}
      >
        <OverPack
          className={`content-template ${props.className}`}
          location={props.id}
          id="about"
        >
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            component="h1"
            key="h1"
            reverseDelay={200}
            id={`${props.id}-title`}
          >
            关于我们
          </TweenOne>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from', delay: 100 }}
            component="p"
            key="p"
            reverseDelay={100}
            id={`${props.id}-content`}
          >
            科技想象力，金融创造力
          </TweenOne>
          <TweenOne.TweenOneGroup
            key="tabs"
            enter={{ y: 30, opacity: 0, delay: 200, type: 'from' }}
            leave={{ y: 30, opacity: 0 }}
            className={`${props.className}-tabs`}
            id={`${props.id}-tabs`}
          >
            <Tabs key="tabs" onChange={this.onChange} activeKey={`${this.state.show}`}>
              {tabsChildren}
            </Tabs>
          </TweenOne.TweenOneGroup>
        </OverPack>
      </div>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/Home/Content3.jsx